import { BodyText } from '@/components/BodyText';
import { TitleText } from '@/components/TitleText';
import { Add, ExpandMore } from '@mui/icons-material';
import { AccordionDetails, AccordionSummary, Box, Button } from '@mui/material';
import { StyledServiceAccountAccordion } from './ServiceAccountCard';

export const ServiceAccountEmptyState = ({ onCreate }: { onCreate: () => void }) => {
  return (
    <StyledServiceAccountAccordion defaultExpanded={true}>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <TitleText>My Service Account</TitleText>
      </AccordionSummary>
      <AccordionDetails>
        <BodyText color='text.secondary' sx={{ mb: 3 }}>
          You don&apos;t have a service account yet. Service accounts allow applications to authenticate with the Physna
          API using OAuth2 client credentials.
        </BodyText>

        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
          <Button
            variant='contained'
            color='primary'
            onClick={onCreate}
            startIcon={<Add />}
            sx={{ borderRadius: '12px' }}
          >
            Create Service Account
          </Button>
        </Box>
      </AccordionDetails>
    </StyledServiceAccountAccordion>
  );
};
